import React, { useState,useEffect,useRef } from "react";
import { Spinner } from 'react-bootstrap';
import {useTheme} from "../../Hooks";

export function IsLoadingHOC(WrappedComponent) {
  function HOC(props) {
    const [isLoading, setLoading] = useState(false);
    const {theme} = useTheme();
    const ref = useRef();
    const showLoading = () => {
      setLoading(true);
    };

    const hideLoading = () => {
      setLoading(false);
    };
      useEffect(() => {
          if(window.location.pathname.includes('/login')){
              ref.current.classList.remove('bootstrapiso')
          }
      }, []);
    return (
      <div ref={ref} className='bootstrapiso' style={{height: '100vh'}}>
        {isLoading && (
          <div
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              zIndex: "900009",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            {}
            <Spinner
              style={{
                width: "4rem",
                height: "4rem",
                color: theme.color1,
              }}
              animation="border"
            />
          </div>
        )}
        <div
          style={
            isLoading === true
              ? {
                  width: "100%",
                  height: "100%",
                  WebkitFilter: "blur(2px)",
                  filter: "blur(2px)",
                  maxHeight: "40px",
                }
              : {
                  minHeight: "inherit",
                }
          }
        >
          <WrappedComponent
            {...props}
            showLoading={showLoading}
            hideLoading={hideLoading}
          ></WrappedComponent>
        </div>
      </div>
    );
  }
  return HOC;
}
export default IsLoadingHOC;
